import { useAppSystem } from "@/global/hooks/useAppSystem";
import React from "react";
import { Box, Button, Chip, Theme, darken, lighten } from "@mui/material";
import { useAppStore } from "@/global/store";
import { seatMapState, selectViewId3d } from "@/global/store/data/seatMap";
import { Map3DViewer } from "../../modules/SeatMap/Map3dViewer";
import { createState } from "@/global/store/zustand_store";
import { getBrowserInfo } from "@/shared/modules/GameFilters/FilterPanels/DateRangeSelector/utils";

const useViewer3d = createState({
  viewer3d: null,
});

export function DVM3dView() {
  const { teamConfig, dispatch } = useAppSystem();
  const { seatMapConfigs } = teamConfig;
  const { venueId } = seatMapConfigs;
  const { viewer3d, set: setViewer3d } = useViewer3d() as any;

  const view_id = useAppStore(selectViewId3d);

  const onLoad = (viewer3d: any) => {
    setViewer3d({ viewer3d });
  };

  const handleBack = () => {
    dispatch(seatMapState.actions.set({ viewId3d: "" }));
  };

  React.useEffect(() => {
    if (viewer3d && view_id) {
      const load_options = {
        venue_id: venueId,
        view_id,
      };

      // disable fullscreen button on iOS
      const browser = getBrowserInfo();
      if (browser?.OS?.name == "iOS") {
        viewer3d.flags.show_fullscreen_button = false;
      }

      viewer3d.has3dView(load_options).then((has3dView: boolean) => {
        if (seatMapConfigs?.dvmFallback3dViewSectionId) {
          if (has3dView) {
            return viewer3d.loadView3d(load_options);
          } else {
            return viewer3d.loadView3d({
              venue_id: venueId,
              view_id: seatMapConfigs?.dvmFallback3dViewSectionId,
            });
          }
        }

        return viewer3d.loadView3d(load_options);
      });
    }
  }, [view_id, viewer3d]);

  return (
    <Box>
      <SeatMap3dActionItems onClickBack={handleBack} />
      <Map3DViewer
        venueId={venueId}
        onLoad={onLoad}
        onError={(error) => {
          console.log("Error loading 3D viewer:");
          console.error(error);
        }}
      />
    </Box>
  );
}

interface SeatMap3dActionItemsProps {
  onClickBack: () => void;
}
function SeatMap3dActionItems(props: SeatMap3dActionItemsProps) {
  const { theme } = useAppSystem();
  const styles = useActionItemsStyles(theme);

  return (
    <Box p={1} sx={styles.wrapper}>
      <Chip
        clickable
        variant="filled"
        onClick={() => props.onClickBack()}
        label={"Back"}
        sx={styles.backButton}
      />
    </Box>
  );
}

function useActionItemsStyles(theme: Theme) {
  const paperBgColor = theme.palette.background.paper;

  return {
    wrapper: {
      position: "absolute",
      width: "fit-content",
      top: 0,
      left: 0,
      zIndex: 1,
    },
    backButton: {
      backgroundColor: paperBgColor,
      "&:hover": {
        backgroundColor: darken(paperBgColor, 0.2),
      },
    },
  };
}
